import { Card, CardActionArea, CardContent, CardMedia } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CompareIcon from '@mui/icons-material/Compare';
import axios from 'axios';
import { useAddToHomeMutation } from '../../redux/Features/ServicesApi';
import swal from 'sweetalert';
import ProductsSkeleton from '../Skeleton/Products/ProductsSkeleton';

const ProductsComponent = ({ products, grid, isLoading }) => {
  const [isHover, setIsHover] = useState(false);
  const [productId, setProductId] = useState(null);
  const [ip, setIp] = useState(null);

  const [addToCart] = useAddToHomeMutation();

  useEffect(() => {
    //  Fetch IP address and set it to the state
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        setIp(response.data.ip);
      } catch (error) {
        // console.error("Error fetching IP address:", error);
        setIp('127.0.0.1');
      }
    };
    fetchIpAddress();
  }, []);

  const hoverHandler = (id) => {
    setIsHover(true);
    setProductId(id);
  };

  const container = {
    open: {
      y: -180,
      opacity: 1,
      transition: { type: 'Tween', duration: 0.4 },
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: { type: 'Tween', duration: 0.4 },
    },
  };

  const handler = async (id) => {
    try {
      const res = await addToCart({
        ip_address: { ip_address: ip },
        id: id,
      }).unwrap();
      if (res?.success) {
        swal('Good job!', 'Add to cart successful!', 'success');
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <ProductsSkeleton />;
  }

  if (!products?.length > 0) {
    return (
      <div className="mx-auto text-center text-xl">
        <p>No products found for this category.</p>
      </div>
    );
  }

  return (
    <>
      <div className={`${grid} items-center gap-5`}>
        {products.length > 0 &&
          products?.map((p, index) => (
            <div
              key={index}
              onMouseEnter={() => hoverHandler(p?.id)}
              onMouseLeave={() => setIsHover(false)}
            >
              <Card sx={{ maxWidth: 1000 }} className="my-2 relative">
                <Link to={`/product-details/${p?.id}/${p?.slug}`}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      image={p?.imageUrl}
                      alt="Men"
                      className="h-56 lg:h-96"
                    />
                    <CardContent>
                      <div>
                        <p className="text-lg text-primary-500 h-14">
                          {p?.name?.length > 16
                            ? `${p?.name.slice(0, 16)}...`
                            : p?.name}
                        </p>
                        <p>৳ {Number(p?.regular_price).toFixed()} TK.</p>
                        <div className="absolute z-30 bottom-5 rounded-md bg-white left-0 right-0 mx-4"></div>
                      </div>
                    </CardContent>
                  </CardActionArea>
                </Link>

                {/* framer motion action */}
                <motion.div
                  className={`${
                    productId === p?.id ? 'block' : 'hidden'
                  } flex items-center z-30 justify-center cursor-pointer gap-5 bg-primary-50 w-44 lg:w-64 absolute right-0 left-0 mx-auto py-2 rounded-md`}
                  variants={container}
                  initial="closed"
                  animate={isHover ? 'open' : 'closed'}
                >
                  <div onClick={() => handler(p?.id)}>
                    <ShoppingCartIcon />
                  </div>
                  <div>
                    <CompareIcon />
                  </div>
                </motion.div>
              </Card>
            </div>
          ))}
      </div>
    </>
  );
};

export default ProductsComponent;
